const KEYS = {
  GUESTUSERDATA: "GUESTUSERDATA",
};

export const GuestUserStorage = {
  saveGuestUserData: (data: any): void => {
    if (data) {
      localStorage.setItem(KEYS.GUESTUSERDATA, JSON.stringify(data));
    }
  },

  getGuestUserData: (): any | null => {
    return JSON.parse(localStorage.getItem(KEYS.GUESTUSERDATA) || "null");
  },

  clear: (): void => {
    Object.values(KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });

    console.log("Cart storage cleared, including checkout ID");
  },
};
